import { IPermissionGroup } from "csd.phoenix.models/PermissionGroup";
import { IUser } from "csd.phoenix.models/User";
import { V3PermissionGroupIds } from "csd.phoenix.models/V3PermissionGroupIds";

export const PATIENT_FORMS_ADMIN_GROUP_NAME = "PatientFormsAdmin";

export enum EFormsAccessLevel {
  // Note: Higher values must indicate higher access levels, since we do value comparions to determine access.
  None = 0,
  User = 1,
  Admin = 2
}

export function findAdminPermissionGroup(groups: IPermissionGroup[]) {
  return groups.find(g => g.Name === "Administrators" && g.RecordStatus === 0);
}

export function findPatientFormsAdminPermissionGroup(groups: IPermissionGroup[]) {
  return groups.find(g =>
    g.RecordStatus === 0 &&
    (Number(g.RecordId) === V3PermissionGroupIds.PatientFormsAdmin || g.Name === PATIENT_FORMS_ADMIN_GROUP_NAME)
  );
}

export function findEFormsPermissionGroup(groups: IPermissionGroup[]) {
  return groups.find(g => g.Name === "PatientForms" && g.RecordStatus === 0);
}



export function getEFormsAccessLevel(userGroups: IPermissionGroup[], user?: IUser) {
  // eForms access is determined ONLY by eForms-specific permission groups
  
  // Check for PatientFormsAdmin group (ID 4) → Admin access
  if (findPatientFormsAdminPermissionGroup(userGroups)) {
    return EFormsAccessLevel.Admin;
  }

  // Check for PatientForms group (ID 2) → User access
  if (findEFormsPermissionGroup(userGroups)) {
    return EFormsAccessLevel.User;
  }

  // No eForms-specific groups → None access
  return EFormsAccessLevel.None;
}




